import { IdentityId } from "./types";
import { setSelectedEnvironmentId } from "src/storage/appState/environment.ts";

const IDENTITY_ID_STORAGE_KEY = "aavo_identity";

const selectedIdentityId = sessionStorage.getItem(IDENTITY_ID_STORAGE_KEY);

export function getSelectedIdentityId() {
	return selectedIdentityId;
}

export const setSelectedIdentityId = (identityId: IdentityId) => {
	if (identityId !== null) {
		console.log("Setting selected identity ID:", identityId);
		sessionStorage.setItem(IDENTITY_ID_STORAGE_KEY, identityId);
	} else {
		sessionStorage.removeItem(IDENTITY_ID_STORAGE_KEY);
	}
	setSelectedEnvironmentId(null);
	window.location.reload();
};
